import React from 'react';
import { useInView } from 'react-intersection-observer';
import './index.css'; // Import the CSS file for animations

const withAnimation = (Component) => {
  return (props) => {
    const { ref, inView } = useInView({
      triggerOnce: true,
      threshold: 0.02,
    });

    return (
      <div
        ref={ref}
        className={`transition-opacity duration-100 ease-in-out ${
          inView ? 'opacity-100 translate-y-0 animate-bounce-in' : 'opacity-0 translate-y-10'
        }`}
      >
        <Component {...props} />
      </div>
    );
  };
};

export default withAnimation;
